const getOnChangeValue = ({
  nativeEvent: {
    target: { value }
  }
}) => parseInt(value);

export default getOnChangeValue;
